import LocalizedStrings from "react-localization";
import en from "./languages/en";
import fr from "./languages/fr";
import it from "./languages/it";
import ro from "./languages/ro";

const supported_languages = ['it', 'en', 'fr', 'ro'];

/** Shape of the dictionary, derived from the real EN file so lang.key is type-checked/autocompleted instead of `any`. */
export type TLang = typeof en;

/** Cache one instance per resolved language instead of rebuilding it on every call - languages() is called directly in render bodies, so a fresh instance every render breaks reference-equality checks downstream (e.g. MUI DataGrid's columns prop). */
const instances: Record<string, ReturnType<typeof buildLocalizedStrings>> = {};

function buildLocalizedStrings(language: string) {
    const strings = new LocalizedStrings<TLang>({
        en: JSON.parse(JSON.stringify(en)) as TLang,
        it: JSON.parse(JSON.stringify(it)) as TLang,
        fr: JSON.parse(JSON.stringify(fr)) as TLang,
        ro: JSON.parse(JSON.stringify(ro)) as TLang,
    });
    strings.setLanguage(language);

    return strings;
}

/** TLang is typed as the plain dictionary shape, but every `lang` in this codebase is actually the LocalizedStrings instance from languages() - this reads its live language code without widening TLang's type everywhere. */
export const getLanguageCode = (lang?: TLang): string => (lang as unknown as { getLanguage?: () => string; })?.getLanguage?.() ?? 'it';

export function languages(language = navigator.language.split('-')[0]) {
    if (!supported_languages.includes(language)) {
        language = navigator.language.split('-')[0];

        if (!supported_languages.includes(language)) {
            language = 'en';
        }
    }

    return instances[language] ??= buildLocalizedStrings(language);
}